export default __webpack_public_path__ + "static/media/wi_04n_broken_clouds.4e4689e4.svg";